export interface ConversationSession {
  token: string;
  conversationId: string;
  streamUrl: string;
  directLineUrl: string;
}

export async function startConversation(
  envBaseUrl: string,
  botSchema: string,
  userId: string
): Promise<ConversationSession> {
  // Step 1: Get regional settings to find the DirectLine URL
  const regionalRes = await fetch(
    `${envBaseUrl}/powervirtualagents/regionalchannelsettings?api-version=2022-03-01-preview`
  );
  if (!regionalRes.ok)
    throw new Error(`Regional settings failed: ${regionalRes.status}`);
  const regionalData = await regionalRes.json();
  const directLineUrl =
    regionalData.channelUrlsById?.directline ||
    'https://directline.botframework.com';

  // Step 2: Get DirectLine token (anonymous)
  const tokenRes = await fetch(
    `${envBaseUrl}/powervirtualagents/botsbyschema/${botSchema}/directline/token?api-version=2022-03-01-preview`
  );
  if (!tokenRes.ok) throw new Error(`Token fetch failed: ${tokenRes.status}`);
  const tokenData = await tokenRes.json();

  // Step 3: Manually start conversation with user ID
  const convRes = await fetch(`${directLineUrl}/v3/directline/conversations`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${tokenData.token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ user: { id: userId } })
  });
  if (!convRes.ok)
    throw new Error(`Conversation start failed: ${convRes.status}`);
  const convData = await convRes.json();

  return {
    token: convData.token,
    conversationId: convData.conversationId,
    streamUrl: convData.streamUrl,
    directLineUrl
  };
}
